// extracted by mini-css-extract-plugin
module.exports = {"balanceSpan":"posDashboard_balanceSpan__2sEn1","balanceDisclaimer":"posDashboard_balanceDisclaimer__3T8jh"};